module.exports = __webpack_public_path__ + "static/media/footer-mobile.1c6ed9c9.png";